import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { BrowserContext } from "./services/BrowserContext";
import Offcanvas from 'react-bootstrap/Offcanvas';

const Profile = ({user,handleUser})=>{
    const {itemsManipulator} = useContext(BrowserContext);
    const [show,setShow] = useState(false);

    const open = () => setShow(true);
    const close = () => setShow(false);

    const logout = () => {
        close();
        itemsManipulator.logout();
        handleUser('');
    }

    // Le navigateur est derrière RequireAuth : `user` est toujours présent ici.
    if(!user){
        return null;
    }

    return (
        <>
            <button type="button" className="app-user-chip" onClick={open}>
                <i className="bi bi-person-circle"></i>
                <span className="app-user-name text-capitalize">{user.name}</span>
                <i className="bi bi-list"></i>
            </button>

            <Offcanvas show={show} onHide={close} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <i className="bi bi-person-circle me-2"></i>
                        <span className="text-capitalize">{user.name}</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex flex-column p-0">
                    <nav className="app-offcanvas-nav">
                        {user.is_admin &&
                            <Link to="/admin" className="app-offcanvas-item" onClick={close}>
                                <i className="bi bi-gear"></i>Administration
                            </Link>
                        }
                    </nav>
                    <div className="mt-auto border-top">
                        <button type="button" className="app-offcanvas-item text-danger w-100" onClick={logout}>
                            <i className="bi bi-box-arrow-right"></i>Se déconnecter
                        </button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Profile
